import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import globals from '../../../globals/communityGlobals';
import VisitActualActivityForm from './VisitActualActivityForm';

const locale = globals.getArea('visitActuals');

export default class VisitActualActivitiesDialog extends React.Component {
  state = { open: false };
  handleOpen = () => this.setState({ open: true });
  handleClose = () => this.setState({ open: false });

  handleAdd = this.props.onAdd;

  render() {
    const {
      usedActivities,
      treatmentInstanceId,
      visitType,
      isSuccessfullyCompleted,
      filterActivitiesByOrgUnit,
    } = this.props;

    return (
      <div className="activity-button">
        <RaisedButton
          primary
          label={locale.getMsg('addActivity')}
          onClick={this.handleOpen}
          disabled={isSuccessfullyCompleted}
        />
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          label={locale.getMsg('addActivity')}
          disabled={isSuccessfullyCompleted}
          disableBackdropClick
        >
          <DialogContent>
            <VisitActualActivityForm
              onRequestClose={this.handleClose}
              onRequestSubmit={this.handleAdd}
              disabledActivities={usedActivities}
              treatmentInstanceId={treatmentInstanceId}
              visitType={visitType}
              isSuccessfullyCompleted={isSuccessfullyCompleted}
              filterActivitiesByOrgUnit={filterActivitiesByOrgUnit}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

VisitActualActivitiesDialog.defaultProps = {
  usedActivities: [],
  treatmentInstanceId: undefined,
  isSuccessfullyCompleted: false,
  visitType: '',
};

VisitActualActivitiesDialog.propTypes = {
  treatmentInstanceId: PropTypes.number,
  onAdd: PropTypes.func.isRequired,
  usedActivities: PropTypes.arrayOf(PropTypes.number),
  visitType: PropTypes.string,
};
